import { render, staticRenderFns } from "./lookFiles.vue?vue&type=template&id=9b901aa6&scoped=true&"
import script from "./lookFiles.vue?vue&type=script&lang=js&"
export * from "./lookFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b901aa6",
  null
  
)

export default component.exports